import { RootState } from 'app/store/rootReducer';
import { setNoSidebarLayoutStyle } from 'app/store/ui';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { Box, SxProps, Theme, useTheme } from '@mui/material';

import AppSuspense from '../../ui/components/AppSuspense';
import LayoutErrorBoundary from '../errors/LayoutErrorBoundary';
import ToolbarLayout from './components/ToolbarLayout';

const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    root: {
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      position: 'absolute',
      display: 'flex',
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
    },
    content: {
      position: 'relative',
      display: 'flex',
      overflow: 'auto',
      flex: '1 1 auto',
      flexDirection: 'column',
      width: '100%',
      WebkitOverflowScrolling: 'touch',
      zIndex: 2,
      marginTop: 8,
    },
  };
};

export default function NoSidebar() {
  const theme = useTheme();
  const styles = getStyles(theme);
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    dispatch(setNoSidebarLayoutStyle());
  }, []);

  return (
    <Box sx={styles.root}>
      <ToolbarLayout isUserLogged={user ? true : false} isWithoutSidebar={true} />
      <Box component="main" sx={styles.content} id="main-scroll-container">
        <LayoutErrorBoundary>
          <AppSuspense>
            <Outlet />
          </AppSuspense>
        </LayoutErrorBoundary>
      </Box>
    </Box>
  );
}
